import { postBiz, json, rows } from '../core/coreapi';
const SERVICE = 'biesimulation';

export const fetchSimulationExecutive = async (scenariocode: string) =>
  json(
    await postBiz({ s: 'biesimulation', a: 'executive', scc: scenariocode })
  );

export const fetchSimulationAssumptions = async (scenariocode: string) =>
  rows(
    await postBiz({ s: 'biesimulation', a: 'assumptions', scc: scenariocode })
  );
  
export const saveSimulationAssumptions = async (
  scenariocode: string,
  records: any[]
) =>
  json(
    await postBiz({
      s: 'biesimulation',
      a: 'saveassumptions',
      scc: scenariocode,
      rcd: records,
    })
  );

export const fetchSimulationMixer = async (scenariocode: string) =>
  json(await postBiz({ s: 'biesimulation', a: 'mixer', scc: scenariocode }));

export const updateSimulationDriver = async (
  scenariocode: string,
  drivercode: string,
  value: number
) =>
  json(
    await postBiz({
      s: 'biesimulation',
      a: 'updatedriver',
      scc: scenariocode,
      drc: drivercode,
      val: value,
    })
  );

export const recomputeSimulation = async (scenariocode: string) =>
  json(
    await postBiz({ s: 'biesimulation', a: 'recompute', scc: scenariocode })
  );

export const fetchSimulationFinancials = async (scenariocode: string) =>
  json(
    await postBiz({ s: 'biesimulation', a: 'financials', scc: scenariocode })
  );

export const fetchSimulationObjectives = async (
  scenariocode: string,
  targetsetcode: string
) =>
  rows(
    await postBiz({
      s: 'biesimulation',
      a: 'objectives',
      scc: scenariocode,
      tsc: targetsetcode,
    })
  );
export const fetchSimulationSensitivity = async (scenariocode: string) =>
  rows(
    await postBiz({ s: 'biesimulation', a: 'sensitivity', scc: scenariocode })
  );

export const runSimulationSensitivity = async (
  scenariocode: string,
  records: any[]
) =>
  json(
    await postBiz({
      s: 'biesimulation',
      a: 'runsensitivity',
      scc: scenariocode,
      rcd: records,
    })
  );

export const submitSimulationForReview = async (
  scenariocode: string,
  notes = ''
) =>
  json(
    await postBiz({
      s: 'biesimulation',
      a: 'submit',
      scc: scenariocode,
      nts: notes,
    })
  );

export const approveSimulation = async (scenariocode: string, notes = '') =>
  json(
    await postBiz({
      s: 'biesimulation',
      a: 'approve',
      scc: scenariocode,
      nts: notes,
    })
  );
